module.exports = __webpack_public_path__ + "static/molecule-5c5ebbf48d9963705d9e27301fee91fc.jpg";